/* src/app/account/account-allocations/cost-allocation/cost-allocation.component.scss */
body#themeTag :host ::ng-deep .p-grid {
  width: 100%;
}
body#themeTag :host ::ng-deep .p-datatable .p-datatable-scrollable-header {
  height: 5.75em;
}
/*# sourceMappingURL=cost-allocation.component.css.map */
